import { createContext } from "react";
import { clone, forEachObjIndexed } from "ramda";

interface DefaultPropsProviderProps<T> {
  children: React.ReactNode;
  value: T;
}

export const DefaultPropsContext = createContext<any>(null);

export const DefaultPropsProvider = <T,>({
  children,
  value,
}: DefaultPropsProviderProps<T>) => {
  const newComponents = clone(value);

  return (
    <DefaultPropsContext.Provider value={newComponents as any}>
      {children}
    </DefaultPropsContext.Provider>
  );
};
